import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { useAccount } from "api/services/useAccount";
import { AccountBillingInfo } from "components/account/ServicePlan/servicePlanUtils";

interface DataLimitState {
  data: AccountBillingInfo;
  loading: boolean;
  error: string | null;
}

const initialState: DataLimitState = {
  data: {
    iqs: 0,
    escalations: 0,
    active_detectors: 0,
    iqs_limit: null,
    escalations_limit: null,
    active_detectors_limit: null,
    stripe_customer_id: null,
  },
  loading: false,
  error: null,
};

export const getDataLimit = createAsyncThunk("dataLimit/getDataLimit", async () => {
  const { accountInfo, accountInfoError } = await useAccount();
  if (!accountInfoError && accountInfo) {
    return accountInfo;
  }
  throw new Error("Failed to fetch data limits");
});

const dataLimitSlice = createSlice({
  name: "dataLimit",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDataLimit.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDataLimit.fulfilled, (state, action: PayloadAction<AccountBillingInfo>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getDataLimit.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch data limits";
      });
  },
});

export default dataLimitSlice;
